import { baseApi } from "./base-api";
import { ApiEndpoints, buildEndpoint } from "@_constants/endpoints";
import {
  ClientUserSearchRequest,
  ClientUserSearchResponse,
  InviteUsersRequest,
  InviteUsersResponse,
} from "@/models/User";

export const usersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    inviteUsers: builder.mutation<
      InviteUsersResponse,
      { dashboardId: string; body: InviteUsersRequest }
    >({
      query: ({ dashboardId, body }) => ({
        url: buildEndpoint(ApiEndpoints.USERS_INVITE, { dashboardId }),
        method: "POST",
        body,
      }),
    }),

    searchClientUsers: builder.mutation<
      ClientUserSearchResponse,
      { dashboardId: string; body: ClientUserSearchRequest }
    >({
      query: ({ dashboardId, body }) => ({
        url: buildEndpoint(ApiEndpoints.DASHBOARD_CLIENT_USERS_SEARCH, {
          dashboardId,
        }),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useInviteUsersMutation, useSearchClientUsersMutation } =
  usersApi;
